const clockedElements = ['bpmn:UserTask', 'bpmn:ServiceTask', 'bpmn:SubProcess', 'bpmn:Task']

const render = (canvas, overlayinfo: any) => {
    const overlays: any = canvas.get('overlays')
    const taskdata: any = Array.from(overlayinfo.taskdata).sort((a: any, b: any) => a.count - b.count)
    const tasks: any = canvas.get('elementRegistry').filter((element) => clockedElements.includes(element.type))
    tasks.forEach((element: any) => {
      const taskCount = taskdata.filter((taskdatum: any) => taskdatum.id === element.id)[0].count
      const taskCountBubble = `<div class='task-count'>${taskCount}</div>`
      overlays.add(element.id, {
        position: {
          bottom: element.height - 10,
          right: element.width - 95
        },
        html: `<div class='task-overlay'>${taskCountBubble}</div>`
      })
    })
}

export default render
